import { NgModule } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
    imports: [
        NgxSkeletonLoaderModule.forRoot({
            theme: {
                extendsFromRoot: true,
                display: 'block',
                margin: 0,
                backgroundColor: 'darkgray'
            },
            animation: "progress",
        }),
    ],
    exports: [NgxSkeletonLoaderModule],
})
export class SharedNgxskeletonloaderModule { }
